import { connect } from 'react-redux';
import FeatureToggleUtils from 'FeatureToggleUtils';
import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import meMenuTemplate from 'hbars!templates/meMenu';
import 'handlebarsHelpers';
import { parse as parseQueryString } from 'query-string';
import { createPortal } from 'react-dom';
import { bindActionCreators } from 'redux';
import { checkIfInCommunityAction, getMeAction } from './actions/CommunityActions';
import { usePrevious } from './utils/ReactHooks';

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getMeAction,
    checkIfInCommunityAction
}, dispatch);

export default (Component) => connect(
    (state) => ({ me: state.meReducer.me }),
    mapDispatchToProps
)(
    (props) => {
        const [isFirstMeRender, setFirstMeRender] = useState(true);

        const { me } = props;
        const hasUserDetails = !!me.id;
        const hasUserDetailsOnFirstMeRender = hasUserDetails && isFirstMeRender;

        const pageCache = FeatureToggleUtils.isFeatureEnabled('pageCache');

        useEffect(() => {
            if (pageCache && !hasUserDetailsOnFirstMeRender) {
                props.getMeAction();
                props.checkIfInCommunityAction();
            }
        }, []);

        const { search } = window.location;
        const { widget: isWidget, preview: isPreview } = useMemo(() => parseQueryString(search), [search]);

        const meElementRef = useRef(null);
        meElementRef.current = meElementRef.current ?? document.querySelector('.navbar-right .header-top-me');
        const hasMeElementRefAssigned = usePrevious(meElementRef.current) !== meElementRef.current;

        const meMenuTemplateWithWrapper = useCallback(({ me }) => <div className="me-container" dangerouslySetInnerHTML={{ __html: meMenuTemplate({ me }) }} />, []);

        const Me = useCallback(
            ({ me }) => {
                setFirstMeRender(false);
                if (meElementRef.current && !hasUserDetailsOnFirstMeRender) {
                    if (hasMeElementRefAssigned) {
                        const meContainer = document.querySelector('.header-top-me .me-container');
                        const meElementChildren = [...meElementRef.current.children];
                        meElementChildren.forEach(child => child !== meContainer && meElementRef.current.removeChild(child));
                    }
                    return createPortal(meMenuTemplateWithWrapper({ me }), meElementRef.current);
                }
                return null;
            },
            [isFirstMeRender, hasUserDetailsOnFirstMeRender, hasMeElementRefAssigned]);


        useEffect(() => {
            !isWidget &&
            pageCache &&
            hasUserDetails &&
            meElementRef.current?.setAttribute('style', 'display: block;');
        }, [hasUserDetails]);

        const shouldNotUpdateMeSection = !pageCache || isWidget;
        if (shouldNotUpdateMeSection) {
            return <Component {...props} />;
        }

        return (
            <Fragment>
                <Me me={me} isWidget={isWidget} isPreview={isPreview} />
                <Component {...props} />
            </Fragment>
        );
    }
);
